import { TicketUser } from "@jugl-web/rest-api/tickets/models/common-types";
import { Avatar } from "@jugl-web/ui-kit";
import { FC } from "react";
import {
  TicketDetailItem,
  TicketDetailItemText,
} from "../../../TicketDetailItem";

const formatUserName = (user: TicketUser): string =>
  [user.first_name, user.last_name].filter(Boolean).join(" ");

interface OpenedByDetailItemProps {
  createdBy: TicketUser;
}

export const OpenedByDetailItem: FC<OpenedByDetailItemProps> = ({
  createdBy,
}) => {
  const userName = formatUserName(createdBy);

  return (
    <TicketDetailItem
      label="Created by"
      content={
        <TicketDetailItemText
          startSlot={
            <Avatar size="sm" imageUrl={createdBy.img} username={userName} />
          }
          text={userName}
        />
      }
    />
  );
};
